// extracted by mini-css-extract-plugin
export default {"contentContainer":"style_contentContainer__JY7iD","wrap":"style_wrap__5L7Y1"};